import { render, staticRenderFns } from "./TiktokConversionApiHistoryList.vue?vue&type=template&id=12a623a8&scoped=true"
import script from "./TiktokConversionApiHistoryList.vue?vue&type=script&lang=js"
export * from "./TiktokConversionApiHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a623a8",
  null
  
)

export default component.exports